<template>
  <DBox
    :id="'cmp-settings-label-mechanical-rates-home'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add')} ${$t('mechanical')}`"
    @addClick="onAddMechanicalRate"
  >
    <NTable
      class="dbox1"
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :id="'settings-label-mechanical-rates-home'"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('rate_name')">
            <TextField2
              id="rate_name"
              class="dbox1"
              :showLabel="false"
              :value="item['rate_name']"
              placeholder="0.00"
              @blur="(e) => onTextInputBlur(e, 'rate_name', item)"
            />
          </td>
          <td v-bind="tdcon('base_amount')">
            <TextField2
              id="base_amount"
              class="dbox1"
              :ta="'right'"
              :showLabel="false"
              :value="item['base_amount']"
              placeholder="0.00"
              @blur="(e) => onTextInputBlur(e, 'base_amount', item)"
            />
          </td>
          <td v-bind="tdcon('time_limit')">
            <TextField2
              id="time_limit"
              class="dbox1"
              :ta="'right'"
              :showLabel="false"
              :value="item['time_limit']"
              placeholder="0.00"
              @blur="(e) => onTextInputBlur(e, 'time_limit', item)"
            />
          </td>
          <td v-bind="tdcon('per_minute')">
            <TextField2
              id="per_minute"
              class="dbox1"
              :ta="'right'"
              :showLabel="false"
              :value="item['per_minute']"
              placeholder="0.00"
              @blur="(e) => onTextInputBlur(e, 'per_minute', item)"
            />
          </td>
          <td v-bind="tdcon('start_date')">
            <!-- <TextField2
              id="start_date"
              class="dbox1"
              :ta="'right'"
              :showLabel="false"
              :value="item['start_date']"
              placeholder="0.00"
              @blur="(e) => onTextInputBlur(e, 'start_date', item)"
            /> -->
            <DatePicker2
              class="dbox1"
              :showLabel="false"
              id="start_date"
              :label="$t('date')"
              :value="item['start_date']"
              @input="(e) => onDateUpdate(e, 'start_date', item)"
            />
          </td>
          <td v-bind="tdcon('end_date')">
            <!-- <TextField2
              id="end_date"
              class="dbox1"
              :ta="'right'"
              :showLabel="false"
              :value="item['end_date']"
              placeholder="0.00"
              @blur="(e) => onTextInputBlur(e, 'end_date', item)"
            /> -->
            <DatePicker2
              class="dbox1"
              :showLabel="false"
              id="end_date"
              :label="$t('date')"
              :value="item['end_date']"
              @input="(e) => onDateUpdate(e, 'end_date', item)"
            />
          </td>
          <td v-bind="tdcon('options')">
            <div class="dt-icon-container">
              <img
                src="static/icons/delete.svg"
                class="dt-icon v5 s1"
                @click="(e) => onDeleteMechanicalRate(item)"
                :alt="`${$t('delete')} ${$t('mechanical')}`"
                :title="`${$t('delete')} ${$t('mechanical')}`"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    rates: {
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("rate_name", { text: "name" }),
        createTableHeader("base_amount", { ta: "right" }),
        createTableHeader("time_limit", { ta: "right" }),
        createTableHeader("per_minute", { ta: "right" }),
        createTableHeader("start_date", { ta: "right" }),
        createTableHeader("end_date", { ta: "right" }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];
    },
    list: function () {
      return this.rates || [];
    },
  },
  methods: {
    onAddMechanicalRate: function (e) {
      this.$emit("added", true);
    },
    onDeleteMechanicalRate: async function (item) {
      const confirmationResult = await confirmDelete(
        this.$t("mechanical"),
        item.rate_name
      );
      if (confirmationResult == "OK") {
        this.$emit("deleted", item);
      }
    },
    onTextInputBlur: function (event, name, item) {
      console.log({ event: event });
      this.$emit("changed", {
        name,
        value: event?.value,
        item,
      });
    },
    onDateUpdate: function ({ value }, name, item) {
      // this.$emit("changed", { name, value });
      this.$emit("changed", {
        name,
        value,
        item,
      });
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-settings-label-mechanical-rates-home {
}
</style>
